module.exports = __webpack_public_path__ + "static/img/4.7dcb74b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/eng/4.png
// module id = q6Os
// module chunks = 0